import validator from 'validator';
import moment from 'moment';

export class FormValidator {
  constructor(validations) {
    this.validations = validations;
  }

  setValidation(validations) {
    this.validations = validations;
  }

  validate(state, validateGroup) {

    // start out assuming valid
    const validation = this.valid();

    try {
      // for each validation rule
      this.validations.forEach(rule => {
        if (state.hasOwnProperty(rule.field) && !validation[rule.field].isInvalid) {
          if (rule.disabled) return;

          if (validateGroup) {
            const group = (rule.group && Array.isArray(rule.group)) ? rule.group : ([rule.group] || []);
            if (group.indexOf(validateGroup) < 0) return;
          }

          const fieldValue = this.getFieldValue(state[rule.field]);
          if (rule.hasOwnProperty('whenSkip')
            && typeof rule.whenSkip === "function"
            && rule.whenSkip(fieldValue)) return;

          const validateEmpty = rule.hasOwnProperty('validateEmpty') ? rule.validateEmpty : true;
          if (!validateEmpty && this.isEmpty(fieldValue)) return;

          const validationMethod = this.getValidationMethod(rule);
          const args = rule.args || [];

          if (validationMethod(fieldValue, ...args, state) !== rule.validWhen) {
            const params = args.length ? args[0] : null;
            validation[rule.field] = {
              isInvalid: true,
              message: (params) ? this.textFormat(rule.message, params) : rule.message
            }
            validation.isValid = false;
          }
        }
      });
    } catch (ex) {
      console.error(ex);
    }

    return validation;
  }

  textFormat(text, values) {
    if (!values) return text;
    return text.replace(/\{(\w+)}/g, function (txt, key) {
      if (values.hasOwnProperty(key)) {
        return values[key];
      }
      return txt;
    });
  }

  valid() {
    const validation = {}
    this.validations.map(rule => (validation[rule.field] = { isInvalid: false, message: '' }));
    return { isValid: true, ...validation };
  }

  getFieldValue(value) {
    return (value !== '' && typeof value === 'number') ? value.toString() : (value || '');
  }

  getValidationMethod(rule) {
    if (typeof rule.method === 'string')
      return validatorCustom[rule.method] || validator[rule.method];
    else return rule.method;
  }

  isEmpty(text) {
    try {
      if (text && Array.isArray(text)) return (text.length === 0);
      else if (typeof text !== 'object') return validator.isEmpty(text);
      return false;
    } catch {
      return false;
    }
  }
}

const validatorCustom = {
  isMoment: date => moment(date).isValid(),
  isSelected: value => !((value === null) || (value === "") || (value.length === 0))
};